import React from 'react';
import { VideoLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingVideoToGifConverterConfig } from '@/data/landingConfig/landingVideoToGifConverterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_VideoToGifConverter } from './schemaObject';

interface Props {}
const VideoToGifConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_VideoToGifConverter} />
			<VideoLandingTemplate
				data={landingVideoToGifConverterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelVideoConverter()}
			/>
		</>
	);
};

export default VideoToGifConverter;
